import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../../../Components/CSS/FilterStyle.css";
import { url } from "../../../../../Config/Config";
import { years } from "../../../../../Components/Data/Session";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class ExamConfigFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classList: [],
    };
  }

  componentDidMount() {
    this.getClasses();
  }

  getClasses = async () => {
    try {
      const response = await Axios.get(`${url}/api/schoolclass`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.classes.length !== 0) {
        this.setState({
          classList: response.data.classes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getClasses();
      }
    }
  };

  render() {
    const { classes, data, handleSearch } = this.props;
    const classFilter = this.state.classList.map((data) => data.className);
    return (
      <div className={classes.root}>
        <div className={classes.title}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="session"
            select
            label="Session"
            variant="outlined"
            margin="normal"
            placeholder="Search by session"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.session}
            onChange={handleSearch}
          >
            <option value="">Select Any One</option>
            {years.map((year, index) => (
              <option key={index} value={year}>
                {year}
              </option>
            ))}
          </TextField>
          <TextField
            name="examType"
            type="text"
            label="Exam Type"
            variant="outlined"
            margin="normal"
            placeholder="Search by examType"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.examType}
            onChange={handleSearch}
          />
          <TextField
            name="className"
            select
            label="Class Name"
            variant="outlined"
            margin="normal"
            placeholder="Search by className"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.className}
            onChange={handleSearch}
          >
            <option value="">Select Any One</option>
            {classFilter
              .filter((value, index) => classFilter.indexOf(value) === index)
              .map((schoolClass, index) => (
                <option value={schoolClass} key={index}>
                  {schoolClass}
                </option>
              ))}
          </TextField>
          <TextField
            name="startDate"
            type="date"
            label="Start Date"
            variant="outlined"
            margin="normal"
            placeholder="Search by start date"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.startDate}
            onChange={handleSearch}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ExamConfigFilter)));
